import React from "react";
import Image from "next/image";
import Link from "next/link";

export type ProductCTAProps = {
  title: string;
  highlight: string;
  buttonText: string;
};

export default function ProductCallToActionSection({
  title,
  highlight,
  buttonText,
}: ProductCTAProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex justify-center h-[220px] items-center relative">
      <Image
        priority
        src="/images/products/world-map.webp"
        alt="Onboarding image"
        height={200}
        width={300}
        className="object-contain absolute left-2 top-10"
      />
      <Image
        priority
        src="/images/products/world-map.webp"
        alt="Onboarding image"
        height={200}
        width={300}
        className="object-contain absolute right-2 bottom-5"
      />

      <div className="flex flex-col gap-4 items-center absolute w-full md:w-4/5">
        <span className="md:text-[45px] text-2xl text-secondary-900 font-bold text-center w-full leading-tight">
          {before}{" "}
          <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
            {highlight}
          </span>{" "}
          {after}
        </span>

        <Link href="/contact" className="flex items-center justify-center">
          <span className="bg-[#4337cc] to-primary-900 border-[#3F26C6] rounded-lg py-2 px-8 text-[#8937F4] inline-block font-semibold">
            <span className=" text-white text-lg md:text-xl">{buttonText}</span>{" "}
          </span>
        </Link>
      </div>
    </section>
  );
}
